import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getComapareFromTenderList } from "../Thunks/tenderThunks";
import { TenderComparison } from "../Types/Tender/TenderCompareInterface";

interface TenderCompareSliceState {
    loader: boolean; // for refres pages and inital loadings
    compareList: TenderComparison[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : TenderCompareSliceState = {
    loader: false,
    compareList:[],
    errorDisplay: '',

}

// set state valu for api response
const tenderCompareSlice = createSlice ({
    name: 'tenderCompareSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getComapareFromTenderList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getComapareFromTenderList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getComapareFromTenderList.fulfilled, (state, action: PayloadAction<TenderComparison[]>) => {
                    state.loader = false;
                    state.compareList = action.payload;
                  })
    }
})

export const {} = tenderCompareSlice.actions
export default tenderCompareSlice.reducer
